<ng-template #template>
    <ng-content>
    </ng-content>
    <ng-container *ngTemplateOutlet="contentTemplateRef()"></ng-container>
</ng-template>